export default window._cmsContent['common/settings']